export const HOST_HISTORY_EVENT_TYPES = {
  DELETE_MODEM: "DELETE_MODEM"
};

export const HOST_HISTORY_EVENT_TYPES_LIST = Object.values(
  HOST_HISTORY_EVENT_TYPES
).map((value) => ({ value, label: value }));
